/**
 * Thin wrapper around the shared single-order `Header` that derives its
 * prop bag from the external-layout data slices.
 *
 * @module singleOrderForExternal/components/OrderHeaderBar
 */
import {
  AuthOnFile,
  GeneralOrderDetails,
  SingleCoverage,
} from "../../../data-model/medicalPaOrdersModel";
import Header from "../../singleOrderLayout/components/header/header";
import { buildHeaderProps } from "../utils/headerPropsBuilder";

interface OrderHeaderBarProps {
  generalOrderDetails:
    { order?: GeneralOrderDetails | null } | null | undefined;
  coverageDetails: { coverages?: SingleCoverage[] } | null | undefined;
  authOnFileDetails: { auth_on_file?: AuthOnFile } | null | undefined;
}

/**
 * @param props - Order, coverage, and auth-on-file slices
 * @returns The composed `Header` with read-only / "external" defaults applied
 */
const OrderHeaderBar = ({
  generalOrderDetails,
  coverageDetails,
  authOnFileDetails,
}: OrderHeaderBarProps) => {
  const headerProps = buildHeaderProps({
    generalOrderDetails,
    coverageDetails,
    authOnFileDetails,
  });
  return (
    <Header
      {...headerProps}
      authorizationId={"N/A"}
      hideButton={true}
      orderData={generalOrderDetails?.order ?? undefined}
      refetchAllData={() => {}}
    />
  );
};

export default OrderHeaderBar;
